export * from './cacheModel/cacheModel';
export * from './defaults';
export * from './functions/getResourceService';
export * from './functions/receiveResourceData';
export * from './functions/receiveResourceRejection';
export * from './functions/requestResource';
export * from './functions/useResource';
export * from './resources/documentResource';
export * from './resources/queryResource';
export * from './cacheModel/selectResourceResult';
export * from './resources/schematicResource';
export * from './schematics/documentSchematic';
export * from './schematics/embedSchematic';
export * from './schematics/listSchematic';
export * from './schematics/querySchematic';
export * from './tasks/invalidator';
export * from './tasks/purger';
export * from './types';
//
// Aliases
//
export { embedSchematic as embed } from './schematics/embedSchematic';
export { listSchematic as list } from './schematics/listSchematic';
export { receiveResourceData as receiveData } from './functions/receiveResourceData';
export { receiveResourceRejection as receiveRejection } from './functions/receiveResourceRejection';
export { requestResource as request } from './functions/requestResource';
//# sourceMappingURL=index.js.map